import {
    Anchor,
    Box,
    Button,
    Center,
    Container,
    Group,
    Paper,
    Stack,
    Text,
    TextInput,
    Title,
    rem,
} from '@mantine/core';
import { isEmail, useForm } from '@mantine/form';

import HCaptcha from '@hcaptcha/react-hcaptcha';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import classes from './ForgotPassword.module.css';
import useRequestReset from '../../../http/mutations/auth/useRequestReset';

const ForgotPassword = ({ ...props }) => {
    const { isPending, mutate: requestReset } = useRequestReset();
    const form = useForm({
        initialValues: {
            email: '',
        },

        validate: {
            email: isEmail('Invalid email'),
        },
    });

    const handleCaptcha = (token, ekey) => {
        form.setFieldValue('captchaResponse', token);
        form.setFieldValue('captchaSessionId', ekey);
    };

    const onSubmit = (model) => {
        requestReset(model);
    };

    return (
        <Container
            size={460}
            my={30}>
            <Title
                className={classes.title}
                ta='center'>
                Forgot your password?
            </Title>
            <Text
                c='dimmed'
                fz='sm'
                ta='center'>
                Enter your email to get a reset link
            </Text>

            <Paper
                withBorder
                shadow='md'
                p={30}
                radius='md'
                mt='xl'>
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Stack>
                        <TextInput
                            label='Your email'
                            placeholder='email@reachsms.vip'
                            {...form.getInputProps('email')}
                            required
                        />
                        <>
                            <HCaptcha
                                id={'login-captcha'}
                                sitekey={import.meta.env.VITE_APP_HCAPTCHA_KEY}
                                onVerify={handleCaptcha}
                            />
                        </>
                    </Stack>

                    <Group
                        justify='space-between'
                        mt='lg'
                        className={classes.controls}>
                        <Anchor
                            component={Link}
                            to={'/auth/login'}
                            className={classes.control}
                            c='dimmed'
                            size='sm'>
                            <Center inline>
                                <IconArrowLeft
                                    style={{ width: rem(12), height: rem(12) }}
                                    stroke={1.5}
                                />
                                <Box ml={5}>Back to the login page</Box>
                            </Center>
                        </Anchor>
                        <Button
                            type='submit'
                            className={classes.control}
                            disabled={isPending}>
                            Reset password
                        </Button>
                    </Group>
                </form>
            </Paper>
        </Container>
    );
};
export default ForgotPassword;
